module.exports = __webpack_public_path__ + "static/img/videobg.d0f6b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/videobg.png
// module id = LZFS
// module chunks = 2